import React from "react";
import AnnouncementBanner from "@/components/sections/AnnouncementBanner";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import Vibe from "@/components/sections/Vibe";
import Highlights from "@/components/sections/Highlights";
import MenuTable from "@/components/sections/MenuTable";
import JelloShotPicker from "@/components/sections/JelloShotPicker";
import GamesRow from "@/components/sections/GamesRow";
import SpotifyJukebox from "@/components/sections/SpotifyJukebox";
import Reviews from "@/components/sections/Reviews";
import KnowBeforeYouGo from "@/components/sections/KnowBeforeYouGo";
import FitCheck from "@/components/sections/FitCheck";
import FooterLocation from "@/components/sections/FooterLocation";
import MobileBottomBar from "@/components/sections/MobileBottomBar";
import "@/App.css";

function App() {
  return (
    <div
      className="App noise-overlay vignette relative min-h-screen bg-[#0A0A0A] text-[#F5F2E6]"
      data-testid="sunnys-landing"
    >
      <AnnouncementBanner />
      <Navbar />
      <main className="relative z-[3]">
        <Hero />
        <Marquee />
        <Vibe />
        <Highlights />
        <MenuTable />
        <JelloShotPicker />
        <GamesRow />
        <SpotifyJukebox />
        <Reviews />
        <KnowBeforeYouGo />
        <FitCheck />
        <FooterLocation />
      </main>
      <MobileBottomBar />
    </div>
  );
}

export default App;
